import { render, staticRenderFns } from "./MasterData.vue?vue&type=template&id=6e976e4a&scoped=true&"
import script from "./MasterData.vue?vue&type=script&lang=js&"
export * from "./MasterData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e976e4a",
  null
  
)

export default component.exports